import React from "react";
import "./About.css";

const About = () => {
  return (
    <div className="about-container">
      <h1>About REWATCHVIEW</h1>
    </div>
  );
};

export default About;
